import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionEnum } from 'src/app/enums/permissions.enum';
import { AuthService } from 'src/app/services/auth/auth.service';

@Directive({
  selector: '[appPermissions]'
})
export class PermissionsDirective implements OnInit {
  @Input('appPermissions') permissions: PermissionEnum[] = [];

  constructor(
    private authService: AuthService,
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>) { }

  ngOnInit(): void {
    const hasPermission = this.authService.userHasPermissions(this.permissions);
    if(hasPermission){
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }else{
      this.viewContainerRef.clear();
    }
  }

}
